module.exports = __webpack_public_path__ + "assets_1775109859079/img/logo.ab3d6f94.png";